import gql from "graphql-tag";

export default gql`
  query sectionArticles($siteId: [QueryArgument]) {
    tags(siteId: $siteId, relatedToEntries: {}) {
      id
      title
      slug
    }
  }
`;
